import React, { Component } from 'react';
import { Create, SimpleForm, TextInput, ReferenceInput, SelectInput, LongTextInput } from 'react-admin';
import Grid from '@material-ui/core/Grid';

const choices = [
    { value: 'true', description: 'Si' },
    { value: 'false', description: 'No' },
];


export default class CompaniesContactCreate extends Component {
    render() {
        return (
            <Create {...this.props} title="Crear contactos para las empresas">
                <SimpleForm>
                    <Grid container justify="center" spacing={16}>
                        <Grid item xs={6}>
                            <TextInput source="first_name" label="Nombres" fullWidth />
                            <TextInput source="last_name" label="Apellidos" fullWidth />
                            <TextInput source="email" label="Correo" fullWidth />
                            <TextInput source="mobile_phone_number" label="Celular" fullWidth />
                            <TextInput source="phone_number" label="Telefono" fullWidth />
                        </Grid>
                        <Grid item xs={6}>
                            <ReferenceInput label="Departamento" source="contact_deparment_id" reference="contact-deparment-options" fullWidth>
                                <SelectInput source="name" />
                            </ReferenceInput>
                            <ReferenceInput label="Empresa" source="company_id" reference="companies" fullWidth>
                                <SelectInput source="name" />
                            </ReferenceInput>
                            <ReferenceInput label="Posición de contacto" source="contact_position_id" reference="contact-position-options" fullWidth>
                                <SelectInput source="name" />
                            </ReferenceInput>
                            <SelectInput source="show_affiliates_directory" label="Mostar a todos los usuarios" choices={choices} optionText="description" optionValue="value" fullWidth />
                            <LongTextInput source="notes" />
                        </Grid>
                    </Grid>
                </SimpleForm>
            </Create>
        )
    }
}